import { totalPrizePool } from '../../../wallet/utils';
const inRange = (value, numMin, numMax) => {
    return value >= numMin && value <= numMax;
};
const RaceFilterComparator = {
    name: (row, filterValues) => row.eventInfo.toLowerCase().includes(filterValues.name.toLowerCase()),
    class: (row, filterValues) => { var _a; return ((_a = row.requirements) === null || _a === void 0 ? void 0 : _a.class) === filterValues.class; },
    raceDate: (row, filterValues) => row.date === filterValues.raceDate,
    entryFee: (row, filterValues) => inRange(row.entryFee.ada, filterValues.entryFeeMin, filterValues.entryFeeMax),
    prizePool: (row, filterValues) => inRange(totalPrizePool(row), filterValues.prizePoolMin, filterValues.prizePoolMax),
    location: (row, filterValues) => row.trackDetails.location.toLowerCase().includes(filterValues.location.toLowerCase()),
    distance: (row, filterValues) => inRange(row.trackDetails.distance, filterValues.distanceMin, filterValues.distanceMax),
    surface: (row, filterValues) => row.trackDetails.surface.toLowerCase() === filterValues.surface.toLowerCase()
};
export default RaceFilterComparator;
